import {useDropzone} from 'react-dropzone'
import {texts} from '../../consts/Texts'

const useImageUpload = (setImageFile, maxSize, setError) => {
    const onSuccess = (acceptedFiles) => {
        setImageFile(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));
        setError("");
    }

    const onFail = (fileRejections) => {
        fileRejections.forEach((file) => {
            file.errors.forEach((err) => {
                if (err.code === "file-invalid-type") {
                    setError(`Error: ${err.message}`);
                }

                if (err.code === "file-too-large") {
                    setError(texts.imageUploader.oversizeError);
                }
            });
        });
    }

    const onDrop = (acceptedFiles, fileRejections) => {
        if(acceptedFiles.length){
            onSuccess(acceptedFiles)
        }

        if(fileRejections.length){
            onFail(fileRejections)
        }
    }

    const useDropzoneOptions = {
        accept: {
            'image/*': ['.png', '.jpeg']
        },
        maxFiles: 1,
        maxSize,
        onDrop,
        noClick: true
    }
    const { getRootProps, getInputProps, open } = useDropzone(useDropzoneOptions);

    return {getRootProps, getInputProps, open}
}

export default useImageUpload